import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CTHero } from '../components/cooltone/CTHero';
import { CTWhatIs } from '../components/cooltone/CTWhatIs';
import { CTVsExercise } from '../components/cooltone/CTVsExercise';
import { CTCandidate } from '../components/cooltone/CTCandidate';
import { CTCombine } from '../components/cooltone/CTCombine';
import { CTAddOns } from '../components/cooltone/CTAddOns';
import { CTFAQ } from '../components/cooltone/CTFAQ';
import { CTWhyChoose } from '../components/cooltone/CTWhyChoose';
export function CoolTonePage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2485">
      <Navigation data-id="element-2486" />
      <main data-id="element-2487">
        <CTHero data-id="element-2488" />
        <CTWhatIs data-id="element-2489" />
        <CTVsExercise data-id="element-2490" />
        <CTCandidate data-id="element-2491" />
        <CTCombine data-id="element-2492" />
        <CTAddOns data-id="element-2493" />
        <CTFAQ data-id="element-2494" />
        <CTWhyChoose data-id="element-2495" />
      </main>
      <Footer data-id="element-2496" />
    </div>;
}